import React, { Component, Fragment } from "react";
import queryString from "query-string";
import { debounce } from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// services
import api from "services/api";

// redux
import {
  Creators as KafkaActions,
  Selectors as KafkaSelectors,
} from "store/ducks/kafka";

// components
import {
  Page,
  Form,
  Panel,
  Breadcrumbs,
  Pagination,
  Loading,
} from "components";
import { Message, Filters } from "./components";

class Messages extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Configurações", to: "/configs" },
      { name: "Mensagens", to: "" },
    ],
    filter: {
      query: "",
      date_start: new Date(),
      date_end: null,
      topic: null,
    },
    selection: [],
    processing: false,
  };

  constructor(props) {
    super(props);

    this.handleSearch = debounce(props.getMessagesRequest, 300);
  }

  // componentDidMount() {
  // const { filter } = this.state;
  // const { location, getMessagesRequest } = this.props;
  // const params = queryString.parse(location.search);
  // const page = params.page ? params.page : 1;

  // getMessagesRequest(page, filter);
  // }

  componentDidUpdate(oldProps) {
    const { filter } = this.state;
    const { location, getMessagesRequest } = this.props;

    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      getMessagesRequest(queryString.parse(location.search).page, filter);
    }
  }

  handleFilter = (e) => {
    e.preventDefault();
    const { filter } = this.state;

    if (filter.date_start === null || filter.date_end === null) {
      alert('Você precisa selecionar o período "DE" e "ATÉ".');
      return;
    }

    this.handleSearch(1, filter);
  };

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;

    const newState = { filter: { ...filter, [name]: value } };

    if (name === "topic" && value.label !== "Lealdade") {
      newState.filter.query = ""
    }

    this.setState(newState);
  };

  handleClean = async (e) => {
    e.preventDefault();

    await this.setState({
      filter: {
        query: "",
        date_start: new Date(),
        date_end: null,
        topic: null,
        status: null,
      },
    });
    // getMessagesRequest(1, this.state.filter);
  };

  handleReprocess = async () => {
    const { selection } = this.state;
    const { filter } = this.state;
    const { location, getMessagesRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    try {
      if (!selection.length) return;

      this.setState({ ...this.state, processing: true });
      await api.post("store/v2/bulk/reactivate_kafka_messages/", {
        kafka_message_ids: selection,
      });
      await this.setState({ ...this.state, selection: [] });
      getMessagesRequest(page, filter);
    } finally {
      this.setState({ ...this.state, processing: false });
    }
  };

  handleSelect = (id) => {
    const { selection } = this.state;

    if (selection.find((selected) => selected === id)) {
      this.setState({
        ...this.state,
        selection: selection.filter((selected) => selected !== id),
      });
    } else {
      this.setState({ ...this.state, selection: [...selection, id] });
    }
  };

  handleSelectAll = () => {
    const { selection } = this.state;
    const { messages } = this.props;

    if (selection.length) {
      this.setState({ ...this.state, selection: [] });
    } else {
      this.setState({
        ...this.state,
        selection: messages.data.map((message) => message.id),
      });
    }
  };

  render() {
    const { breadcrumbs, selection, filter, processing } = this.state;
    const { messages } = this.props;

    return (
      <Page className="page-messages">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="message-header">
          <Page.Title>Mensagens</Page.Title>
          <button
            type="button"
            disabled={!selection.length || processing}
            onClick={this.handleReprocess}
          >
            <i className="fa fa-refresh" />
            {processing ? "Reprocessando..." : "Reprocessar selecionados"}
          </button>
        </header>

        <Filters
          data={filter}
          onChange={this.handleChangeFilter}
          onSubmit={this.handleFilter}
          onClean={this.handleClean}
        />

        <Panel className="panel-list">
          {!messages.data.length && messages.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {messages.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>
                      <Form.Checkbox
                        checked={selection.length === messages.data.length}
                        onChange={this.handleSelectAll}
                      />
                    </th>
                    <th>tópico</th>
                    <th>offset</th>
                    <th>key</th>
                    <th>status processo</th>
                    <th></th>
                    <th>data de processo</th>
                    <th>data</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!messages.data.length && (
                    <tr>
                      <td colSpan="8" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {messages.data.map((message, index) => (
                    <Message
                      message={message}
                      key={String(message.id)}
                      selected={selection.find(
                        (selected) => selected === message.id
                      )}
                      onSelect={() => this.handleSelect(message.id)}
                    />
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="8" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                className="m-t-20"
                current={messages.page}
                total={messages.total}
                {...this.props}
              />
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}
const mapstate = (state) => ({
  messages: {
    ...state.kafka.messages,
    data: KafkaSelectors.messages(state.kafka.messages.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(KafkaActions, dispatch);

export default connect(mapstate, mapActions)(Messages);
